import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { CustomizerSettingsService } from '../customizer-settings/customizer-settings.service';
import { TranslocoModule } from '@ngneat/transloco';


@Component({
    selector: 'app-starter',
    standalone: true,
    imports: [TranslocoModule, RouterLink, MatCardModule, MatButtonModule, NgIf],
    templateUrl: './starter.component.html',
    styleUrl: './starter.component.scss'
})
export class StarterComponent {

    constructor(
        public themeService: CustomizerSettingsService
    ) {

    }

}
